export default "__VITE_ASSET__Dg3Ba$6z__"